<template>
  <div>
    <div class="row l-m-b-16">
      <div class="col-6">
        <h2 class="l-header-2">FORM INFO</h2>
        <br />
        <span class="section-disclaimer">
          All you need for the form to work is in the iframe. You will copy the iframe into your code and have a working quote within minutes.
          In the image below you can see an example how the form looks when it’s placed over a page with a background image.        </span>
        <div class="row mb-3 mt-3 pl-3 pr-3">
          <img src="../../assets/img/form-widget-min.png" />
        </div>
      </div>
      <div class="col-6">
        <h2 class="l-header-2">IFRAME for your website</h2>
        <br />
        <span class="section-disclaimer">
          Click and copy the script to the clipboard. Paste it into your website in the position you want. The width of the iframe is dependant on the parent element or wrapper. The iframe can be pasted into a &lt;div&gt; element which would dictate the position of your quote form.
        </span>
        <div class="row mb-3 mt-3 pl-3 pr-3">
          <div class="select-wrap h-auto">
            <!-- eslint-disable-next-line -->
            <textarea class="select-wrap-textarea form-control" rows="8" ref="script" @click="doCopy">&lt;iframe width="100%" height="460px" src="{{widgetUrl}}" frameborder="0" style="border: 0; order: 2;border-radius: 5px;" scrolling="no" marginheight="0" marginwidth="0" &gt;&lt;/iframe&gt;                </textarea>
          </div>
        </div>

        <div class="row mt-3 pl-3 pr-3 d-flex justify-content-end">
          <div class="assistance" @click="$emit('setStepCustom')">
            Switch to custom form?
          </div>
        </div>
        <div class="row mt-3 pl-3 pr-3 d-flex justify-content-end">
          <div class="assistance" @click="$emit('setStepEditing')">
            Switch to simple button?
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import toastr from 'toastr';

export default {
  props: {
    company: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    url: process.env.NODE_ENV,
  }),
  computed: {
    widgetUrl() {
      if (this.url === 'production') {
        return `https://widget.mod24.com/mod24frame.html?key=${this.company.web_key}`;
      }
      return `https://widget.24mod.com/mod24frame.html?key=${this.company.web_key}`;
    },
  },
  methods: {
    doCopy() {
      this.$copyText(this.$refs.script.defaultValue).then(() => {
        toastr.success('Copied iframe to clipboard');
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.select-wrap {
  width: 100%;
}
.script-template {
  height: 250px;
  overflow-y: scroll;
}
.instructions {
  height: 502px;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/companies/CompaniesWebQuoteIframe.vue